import { EnumBase } from 'hay-core-react';
class ConfiguracaoRequercidadeEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.requercidade.desativado',
                'main.configuracao.requercidade.opcional',
                'main.configuracao.requercidade.obrigatorio',
            ],
            'main.configuracao.requercidade.desativado'
        );
    }
}

const instance = new ConfiguracaoRequercidadeEnum();
export default instance;
